module.exports = __webpack_public_path__ + "img/behance.3566e419.svg";